import React, { Component } from 'react';
import _, { isEmpty, get, method } from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router-dom';

import asyncRoute from '../../../helpers/hoc/asyncRoute';
import routes from '../../../routes';
import BinarySelect from '../../../components/BinarySelect'
import MultiSelect from '../../../components/FormElements/MultiSelect'

import Input from '../../../components/FormElements/Input';
// import File from '../../../../../components/FormElements/File';
import Textarea from '../../../components/FormElements/Textarea';
// import Select from '../../../components/FormElements/Select';
import Select from '../../../components/FormElements/SelectNew';
import DatePicker from '../../../components/Datepicker'
import ModalConfirmation from '../../../components/ModalConfirmation';
// import MultiSelect from '../../../components/FormElements/MultiSelect';
import TimePicker from '../../../components/FormElements/TimePicker';
import { handleFieldError, initializeForm, handleError } from '../../../utils/form-validation';
import { formFields, confirmationMessage, successfullyMessage, platformtype, dvPlatform, IONplatform, Goal, roStaus } from './constant';
// import { bidderReport } from '../Io/constant';
import { addIoReportAction, getIoAdvertisersReportAction, getIoEditIdReportAction, getCategoryAction, getSUbCategoryAction, getPrimaryGoalAction, getSecondaryGoalAction, createRoAction, mapExistingRoAction, roListNamesAction, uploadFileAction, getUnmappedCampaignListAction } from '../../../actions';
import { sortArray } from '../../../selectors';
import CheckboxGroup from '../../../components/FormElements/CheckboxGroup';
import RadioGroup from '../../../components/FormElements/RadioGroup'
import { log } from 'async';
import "../ro.scss"
import { imageUrl } from "../../../constants/configuration";
import ToastModal from "../../../components/ToastModal";
// import BinarySelect from '../../../components/BinarySelect'

const Card = asyncRoute(() => import('../../../components/Card'));
const BreadCrumb = asyncRoute(() => import('../../../components/BreadCrumb'));

class AddRo extends Component {
  constructor(props) {
    super(props);
    this.fileRef = React.createRef();
    this.state = {
      roForm: {
        sdate: moment(new Date().setDate(new Date().getDate() - 7)).toDate(),
        edate: new Date(),
      },
      form: {},
      touched: {},
      errors: {},
      editMode: false,
      submited: false,
      confirmationOpen: false,
      confirmationInfo: '',
      mappedCampaigns: [],
      creativeUrl: '',
      unmappedDataList: [],
      roListNames: [],
      toastStatus: "",
      toastMsg: "",
      enableToast: "",
      confirmationMsg: "",
      poc: ''
    };
  }

  async componentWillMount() {
    const { match: { params: { id } }, tenantId, authToken, userId, getIoAdvertisersReportAction, configurationList } = this.props;
    // const { match: { params: { id } }, tenantId, authToken, userId, updateRoAction, history, match } = this.props;
    const currency = get(configurationList.find(currency => currency.attrName === 'CURRENCY'), 'attributeValues', []);
    let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
    if (isEmpty(isAuthenticated)) {
      const { history } = this.props;
      history.push(routes.preSignIn);
    }
    const { form, errors } = initializeForm(formFields);

    // form.campaigncategory = "NEW";
    let curreValue = currency.find(a => a.value == "USD");
    if (curreValue) {
      form.currency = curreValue.key;
    }
    form.startDate = moment().toDate();
    form.advertiserId = tenantId;
    this.setState({ form, errors });

    await this.fetchExistsRO();

    getIoAdvertisersReportAction(tenantId, authToken, userId);
    await this.listRoNames();
  }

  fetchExistsRO = async () => {
    const { getUnmappedCampaignListAction, tenantId, authToken, userId, match: { params: { id } },history } = this.props
    const idArr = JSON.parse(localStorage.getItem("unmappedIdArr"));

    const {
      responseCode: { status = "" },
      responseList,
    } = await getUnmappedCampaignListAction({ tenantId, authToken, userId });
    if (status == "Success") {
      const data = responseList;

      data.forEach(e => {
        if (e.url === undefined) {
          Object.assign(e, { url: '' })
        }
      })

      if (idArr.length > 0) {
        const filteredIds = data.filter(item => idArr.includes(item.campaignId));
        if(filteredIds.length > 0){
          this.setState({ unmappedDataList: filteredIds });
          }
          else{
            history.push('/' + routes.mainRoute + '/' + routes.containers.unmappedCampaign);
          }

      } else {
        const findMappedData = data.filter(item => item.campaignId == idArr);
        if(findMappedData.length > 0){
           this.setState({ unmappedDataList: findMappedData });
        }
        else{
          history.push('/' + routes.mainRoute + '/' + routes.containers.unmappedCampaign);
        }
      }
    }

  }

  handleChange = (e) => {
    let { form, categoryData, primaryGoalData, secondaryGoalData, subCategoryData } = this.state;
    let { value, name } = e.target;
    form[name] = value;
    this.setState({ form });

    if (name === "campaigncategory") {
      const categoryValue = value;
      const filterCategory = categoryData.find(cat => cat.text === categoryValue);
      form.campaigncategory = filterCategory.id
      this.setState({ form })
      this.subCategoryApiFunction(filterCategory.id)
    }

    if (name === "subCampaigncategory") {
      const subCategory = value;
      const findSubCat = subCategoryData.find(item => item.text == subCategory);
      form.subCampaigncategory = findSubCat.categoryID;
      this.setState({ form });
    }

    if (name === "primaryGoal") {
      const primaryGoalValue = value;
      const filterPrimaryGoal = primaryGoalData.filter(goal => {
        return goal.value === primaryGoalValue
      })

      if (filterPrimaryGoal.length > 0) {
        filterPrimaryGoal.map(data => {
          this.setState({ primaryGoalId: data.id })
          this.secondaryApiFunction(data.id)
        })
      }
    }

    if (name === "secondryGoal") {
      const secondaryGoalValue = value;



      const filterSecondaryGoal = secondaryGoalData.filter(goal => {
        return goal.value === secondaryGoalValue
      })

      if (filterSecondaryGoal.length > 0) {
        filterSecondaryGoal.map(secData => {
          this.setState({ secondaryGoalId: secData.id })
        })
      }

    }
  };


  handleTouch = (e) => {
    let { touched, form, errors } = this.state;
    let { error } = handleFieldError(form[e.target.name], formFields[e.target.name]);
    errors[e.target.name] = error;
    touched[e.target.name] = true;
    this.setState({ touched, errors });
  };

  toggleModal = (confirmation) => {
    const { confirmationOpen } = this.state;
    this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: confirmation });
  };

  confirmationCallBack = (success, info) => {
    const { confirmationOpen } = this.state;
    if (success && info.action.type === 'Confirmation') {
      this.mapWithExistRO();
      // this.submitForm();
    } else if (info.action.type === 'alert') {
      this.setState({ confirmationOpen: !confirmationOpen }, () => {
        const { history } = this.props;
        history.push('/' + routes.mainRoute + '/' + routes.containers.unmappedCampaign);
      });
      return;
    } else if (info.action.type === 'Success') {
      this.setState({ confirmationOpen: !confirmationOpen }, () => {
        const { history } = this.props;
        history.push('/' + routes.mainRoute + '/' + routes.containers.unmappedCampaign);
      });
      return;
    }

    this.setState({ confirmationOpen: false });
  };

  reset = () => {
    return {
      advertiserId: '',
      brief: '',
      startDate: '',
      endDate: '',
      name: '',
      budget: '',
      currency: '',
      DeleteID: null,
      method: "",
      poc: false
    };
  };


  deleteAlert = (campaignId) => {
    this.setState({ enableToast: true, confirmationMsg: "Are You Sure To Delete?", poc: true, method: "delete", DeleteID: campaignId });
  }



  deleteCampaign = (campaignId) => {
    let status = "Success"
    let msg
    if (status) {
      this.toast(status, msg = "Successfully Deleted")
      const { unmappedDataList } = this.state;
      var mappedCampaignsFilter = unmappedDataList.filter(x => {
        return x.campaignId != campaignId;
      })

      this.setState({ unmappedDataList: mappedCampaignsFilter })
    }
  }

  toggleAlertModal = (confirmation) => {
    const { confirmationOpen } = this.state;
    this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: confirmation })
  }

  filesUpload = async (e, index) => {
    const urlName = e.target.name;
    let { uploadFileAction, ioAdvertisersReport } = this.props;
    const { form, unmappedDataList } = this.state;
    console.log(form, "Form", unmappedDataList)
    const data = new FormData();

    const blob = e.target.files[0];

    data.append('file', blob, blob.name);

    const response = await uploadFileAction(data, form.advertiserId, 'image');
    if (response && response.responseCode && response.responseCode.status === 'Success') {
      const list = [...unmappedDataList];
      list[index][urlName] = response.responseList;
      this.setState({ unmappedDataList: list });
    } else {
      let info = { action: { confirmationMessage: response.responseCode.desc, type: 'error' } }
      this.toggleAlertModal(info);
    }
  }

  deleteFile = (index) => {
    const { unmappedDataList } = this.state;
    const list = [...unmappedDataList];
    list[index]["url"] = "";
    this.setState({ unmappedDataList: list });
  }

  // ======= existing ro list ======= 
  // listRoNames = async () => {
  //   const { tenantId, authToken, userId, roListNamesAction } = this.props;
  //   const {
  //     responseCode: { status = "" },
  //     responseList,
  //   } = await roListNamesAction({ tenantId, authToken, userId });
  //   if (status === "Success") {
  //     const roList = responseList.map((item, index) => {
  //       return { key: item.id, value: item.name };
  //     });

  //     this.setState({ roListNames: roList })
  //   }
  // }


    // ======= existing ro list ======= 
    listRoNames = async () => {
      const { tenantId, authToken, userId, roListNamesAction } = this.props;
      const { form } = this.state;
      const {
        responseCode: { status = "" },
        responseList,
      } = await roListNamesAction({ tenantId, authToken, userId });
      if (status === "Success") {
        const roList = responseList.map((item, index) => {
          return { key: item.id, value: item.name };
        });
  
        if(roList.length == 1){
          form.existingRO = roList[0].value;
        }
  
        this.setState({ roListNames: roList,form })
      }
    }


  // ========== add to exists RO ===========
  mapWithExistRO = async () => {
    const { form, roListNames, unmappedDataList } = this.state;
    console.log("existingRO",form.existingRO)
    console.log("roListNames",roListNames)
    if (form.existingRO != "") {
      const roID = roListNames.find(ro => ro.key == form.existingRO);
      console.log("roID",roID)

      const unmappedCampaignData = unmappedDataList.map(({ platform, ...rest }) => ({ ...rest }));
      const payload = {
        roId: roID.key,
        roName: form.existingRO,
        campMap: unmappedCampaignData
      }

      const { tenantId, authToken, userId, mapExistingRoAction, history, match } =
        this.props;

      const {
        responseCode: { status = "", msg = "" },
      } = await mapExistingRoAction({
        tenantId,
        authToken,
        userId,
        payload
      });

      if (status) {
        this.toast(status, msg);
      }
    }
  }

  handleSave = () => {
    this.setState({ enableToast: true, confirmationMsg: "Are You Sure To Map A Campagin With RO?", method: "save", poc: false });
  }

  toast = (status, msg) => {
    this.setState({ enableToast: true, toastStatus: status, toastMsg: msg });
    return;
  }

  confirmationCallbackModel = (id) => {
    const { method, DeleteID } = this.state
    this.setState({ enableToast: false }, () => {
      if (method == "delete") {
        this.deleteCampaign(DeleteID)

      } else if (method == "save") {

        this.mapWithExistRO();
      }
    });

  }

  handleToastStatus = (status) => {
    this.setState({ enableToast: status, toastStatus: "", toastMsg: "" });
  }

  render() {
    const maxDate = new Date();
    const { confirmationOpen, confirmationInfo, submited, errors, touched, toastStatus, toastMsg, enableToast, form, editMode, roListNames, unmappedDataList, confirmationMsg, poc } = this.state;
    const { ioAdvertisersReport, match: { params: { id } }, match } = this.props;
    return (
      <>
        {confirmationOpen && (<ModalConfirmation
          open={confirmationOpen}
          onClose={this.toggleModal}
          confirmationInfo={confirmationInfo}
          handelConfirmationMessage={this.confirmationCallBack}
        />)}

        {
          enableToast && <ToastModal
            enableToast={enableToast}
            status={toastStatus}
            msg={toastMsg}
            path={routes.containers.unmappedCampaign}
            idProps={this.props}
            handleConfirmation={this.confirmationCallbackModel}
            handleToastStatus={this.handleToastStatus}
            confirmationMsg={confirmationMsg}
            poc={poc}
          />
        }
        <div className="main-panel ion">
          <div className="content-wrapper">
            <BreadCrumb />
            <div className="row justify-content-center mt-3">
              <div className="col-md-12 grid-margin">
                <Card>
                  <div className='row mt-n2'>
                    <div className="col-md-4 pr-4">

                      <Select
                        onChange={this.handleChange}
                        onBlur={this.handleTouch}
                        value={form[formFields.existingRO.key]}
                        setting={formFields[formFields.existingRO.key]}
                        error={errors[formFields.existingRO.key]}
                        submited={submited}
                        touched={touched[formFields.existingRO.key]}
                        options={roListNames}
                      />
                    </div>

                    {
                      unmappedDataList.length > 0 && (
                        <div className="col-md-12 p-0 btn-block text-left mt-4 badgeText">
                          <p style={{ fontSize: '14px' }}>Campaign DSP Mapping</p>
                        </div>
                      )
                    }

                    {
                      unmappedDataList != undefined && unmappedDataList.length > 0 && unmappedDataList.map((e, index) => (
                        <div className='row w-100'>
                          <div className='col-md-4 mt-3'>
                            <Input
                              onChange={this.handleChange}
                              onBlur={this.handleTouch}
                              value={e.platform}
                              setting={formFields[formFields.dspPlatform.key]}
                              error={errors[formFields.dspPlatform.key]}
                              submited={submited}
                              touched={touched[formFields.dspPlatform.key]}
                              disabled
                            />
                          </div>
                          <div className='col-md-4 mt-3'>
                            <Input
                              onChange={this.handleChange}
                              onBlur={this.handleTouch}
                              value={e.name}
                              setting={formFields[formFields.campaignName.key]}
                              error={errors[formFields.campaignName.key]}
                              submited={submited}
                              touched={touched[formFields.campaignName.key]}
                              disabled
                            />
                          </div>
                          <div className='col-md-3 mt-3'>
                            <label htmlFor="getUpload" className="col-sm-12 col-form-label" style={{ fontSize: '14px', padding: "10px 0px" }}>Dashboard Thumbnail</label>

                            {
                              e.url != '' ? <div className='mappedImg'><img src={e.url} />
                                <button onClick={() => this.deleteFile(index)}>
                                  <i className="mdi mdi-close text-dark"></i>
                                </button>
                              </div> :
                                <input name="url" accept="image/*"
                                  onChange={(e) => this.filesUpload(e, index)} type="file" />
                            }

                          </div>
                          {
                            unmappedDataList.length > 1 ?
                              <div className='col-md-1 mt-3 flexClass'>
                                <button className="btn-remove" onClick={() => this.deleteAlert(e.campaignId)} style={{ top: '3px' }} ><i className='mdi mdi-delete'></i></button>

                              </div>
                              : ""
                          }
                        </div>
                      ))
                    }


                    <div className="form-group row mt-5" style={{ width: "100%" }}>
                      <div className="col-sm-12">
                        <center>
                          <button type="submit" onClick={() => this.handleSave()} className="btn btn-primary">Add to Existing RO</button>
                          <Link to={'/' + routes.mainRoute + '/' + routes.containers.unmappedCampaign}><button type="button" className="btn btn-secondary ml-2">Cancel</button></Link>
                        </center>
                      </div>
                    </div>
                  </div>

                </Card>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect(
  state => ({
    configurationList: get(state, 'app.configurationData.responseList', []),
    ioAdvertisersReport: get(state, 'app.ioAdvertisersReport.responseList', []),
    tenantId: get(state, 'app.preSignInState.tenantId', ''),
    userId: get(state, 'app.preSignInData.userId', ''),
    authToken: get(state, 'app.signInData.authToken', '')
  }),
  {
    addIoReportAction,
    getIoAdvertisersReportAction,
    getIoEditIdReportAction,
    getCategoryAction,
    getSUbCategoryAction,
    getPrimaryGoalAction,
    getSecondaryGoalAction,
    createRoAction,
    roListNamesAction,
    uploadFileAction,
    getUnmappedCampaignListAction,
    mapExistingRoAction
  }
)(AddRo);

// ----*  IO propTypes * ----
AddRo.propTypes = {
  addIoReportAction: PropTypes.func,
  getIoAdvertisersReportAction: PropTypes.func,
  configurationList: PropTypes.array,
  ioAdvertisersReport: PropTypes.array,
};